import { render, staticRenderFns } from "./rbca.vue?vue&type=template&id=fb7b2802&scoped=true&"
import script from "./rbca.vue?vue&type=script&lang=js&"
export * from "./rbca.vue?vue&type=script&lang=js&"
import style0 from "./rbca.vue?vue&type=style&index=0&id=fb7b2802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7b2802",
  null
  
)

export default component.exports